const ChatDisabledBanner = () => (
  <div className='flex justify-between items-center bg-blue-100 rounded-lg p-3 text-blue-700 m-3'>
    <p className='leading-tight'>
      Your Mindjoy license is not active. Please ask your educator to activate your account if this is a mistake.
    </p>
  </div>
)

export default ChatDisabledBanner
